import React from 'react';
import logo from '../../../assets/icons/LOGO_BLANCO.svg';
import { FormattedMessage } from 'react-intl';
import './Footer.component.scss';
import {
  footerLinks,
  IExternalLink,
  homeLink,
} from '../../../assets/constants/external-links';

export function FooterComponent(props: any) {
  return (
    <footer className='footer d-flex justify-content-between'>
      <a
        href={homeLink.link}
        aria-label={homeLink.name}
        target='_blank'
        rel='noopener noreferrer'
      >
        <div className='logo-container'>
          <img src={logo} alt='logo' />
        </div>
      </a>
      <div className='links-container'>
        <ul>
          {footerLinks.map((el: IExternalLink, idx: number) => {
            return (
              <li key={`footer-link-${idx}`} className='footer-link'>
                <a
                  href={el.link}
                  aria-label={el.name}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FormattedMessage id={`common.${el.name}`} />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </footer>
  );
}
